import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IonicModule, PopoverController } from '@ionic/angular';

@Component({
    selector: 'app-file-popover',
    templateUrl: './file-popover.component.html',
    styleUrls: ['./file-popover.component.scss'],
    imports: [IonicModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilePopoverComponent {

  constructor(public popoverController: PopoverController) { }

  readonly canShare = input<boolean>(undefined);

  share() {
    this.popoverController.dismiss('share');
  }

  download() {
    this.popoverController.dismiss('download');
  }

  delete() {
    this.popoverController.dismiss('delete');
  }

}
